angular
  .module('deskfy.arts')
  .controller('UserLatestNewsController', UserLatestNewsController)

/* @ngInject */
function UserLatestNewsController ($scope, $state, $timeout, $window, $translate, ArtsService, ToastService) {
  $scope.breadcrumbs = {
    items: []
  }
  $scope.search = {
    filters: [],
    state: {
      loading: false,
      searching: false
    },
    results: [],
    totalCount: 0,
    pagination: {
      top: 20,
      skip: 0
    }
  }

  $scope.news = {
    state: {
      loading: true
    },
    pagination: {
      $top: 20,
      $skip: 0
    },
    results: [],
    totalCount: 0
  }

  const api = {
    _loadBreadcrumbs,
    _loadNewTemplates,
    _getFiltersForNewTemplatesRequest
  }
  this.getApi = () => api

  activate()
  function activate () {
    api._loadBreadcrumbs()
    api._loadNewTemplates()

    $timeout(() => {
      $window.scrollTo(0, 0)
      $scope.$parent.sidebar.selectedMenuId = 1
    }, 100)
  }

  /**
   * Handle load more news.
   */
  $scope.handleLoadMoreNews = function () {
    api._loadNewTemplates()
  }

  /**
   * Handle filters change of <user-search-bar> component and apply to request.
   */
  $scope.handleFilterChange = function (filters) {
    $scope.search.filters = filters
    $scope.search.state.searching = Object.keys(filters).length > 0
    $scope.news = {
      ...$scope.news,
      results: [],
      totalCount: 0,
      state: {
        ...$scope.news.state,
        loading: true
      },
      pagination: {
        ...$scope.news.pagination,
        $skip: 0
      }
    }

    $timeout(() => {
      api._loadNewTemplates()
    }, 500)
  }

  /**
   * Normalize filters to request.
   */
  function _getFiltersForNewTemplatesRequest () {
    const startDate = new Date()
    startDate.setDate(startDate.getDate() - 15)
    return {
      $top: $scope.news.pagination.$top,
      $skip: $scope.news.pagination.$skip,
      $orderBy: [{ field: 'templateScheduleDate', type: 'DESC' }, { field: 'templatePublicationDate', type: 'DESC' }],
      startDate: startDate.toISOString(),
      ...($scope.search.filters ?? {})
    }
  }

  /**
   * Load new templates to show on news section.
   */
  function _loadNewTemplates () {
    $scope.news.state.loading = true
    ArtsService.getRecentTemplates(api._getFiltersForNewTemplatesRequest())
      .then(response => {
        $scope.news.results = [...$scope.news.results, ...(response?.rows ?? [])]
        $scope.news.totalCount = response.count
        $scope.news.pagination.$skip += $scope.news.results.length
      })
      .catch(() => ToastService.showErrorToast($translate.instant('userArts.news.error')))
      .finally(() => { $scope.news.state.loading = false })
  }

  /**
   * Normalize breadcrumb.
   */
  function _loadBreadcrumbs () {
    const root = {
      id: 'user.arts',
      label: $translate.instant('userArts.arts.title')
    }
    const current = {
      id: 'user.latestNews',
      label: $translate.instant('userArts.news.all')
    }

    $scope.breadcrumbs = {
      items: [root, current],
      onChange: (event) => {
        $state.go(event.id)
      }
    }
  }
}

export { UserLatestNewsController }
